import React from 'react';
import Chart from 'react-apexcharts';
import { getCompactDollars } from '../../agent-production/helpers/dataFormatters';
import { chartFontFamily } from '../../market-dynamics/constants';
import { terms, viewTypes } from '../constants';
import PropTypes from 'prop-types';

const TransactionVolumeChart = ({ chartData, selectedOffice, viewTypeId }) => {
    const chartOptions = {
        chart: {
            type: 'line',
            toolbar: {
                show: false
            },
            fontFamily: chartFontFamily,
            offsetX: 20,
        },
        grid: {
            borderColor: '#E5E7EB',
        },
        stroke: {
            width: [0, 2],
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                borderRadius: 6,
                borderRadiusApplication: 'end'
            }
        },
        colors: ['#236847', '#0284C7'],
        dataLabels: {
            enabled: false
        },
        labels: chartData.categories,
        xaxis: {
            type: 'category',
            labels: {
                style: {
                    colors: '#9CA3AF',
                    fontWeight: '600',
                    lineHeight: '16px',
                    cssClass: 'apexcharts-xaxis-dashboard-label'
                }
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            labels: {
                formatter: function(value) {
                    return getCompactDollars(value);
                },
                style: {
                    colors: '#9CA3AF',
                    fontSize: '14px',
                    lineHeight: '20px'
                }
            },
        },
        tooltip: {
            enabled: false
        },
        legend: {
            show: false 
        },
        fill: {
            opacity: 1
        }
    };

    const chartSeries = [
        {
            name: viewTypeId === viewTypes.byOffice ? (selectedOffice?.name || terms.selectedOffice) : viewTypes.byBrokerage,
            type: 'column',
            data: chartData.transactionVolumes
        },
        {
            name: terms.marketAverage,
            type: 'line',
            data: chartData.marketAverages
        }
    ];

    return (
        <div className="mt-3">
            <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                width="100%"
                height="245px"
            />
        </div>
    );
};

TransactionVolumeChart.propTypes = {
    chartData: PropTypes.shape({
        categories: PropTypes.arrayOf(PropTypes.string).isRequired,
        transactionVolumes: PropTypes.arrayOf(PropTypes.number).isRequired,
        marketAverages: PropTypes.arrayOf(PropTypes.number).isRequired,
    }).isRequired,
    selectedOffice: PropTypes.shape({
        name: PropTypes.string,
        mlsOfficeId: PropTypes.object,
    }),
    viewTypeId: PropTypes.string,
};

export default TransactionVolumeChart;
